import React from 'react'
import { PaymentInterval } from './Recurly'
import SelectTideways6Plans from './SelectTideways6Plans'
import Summary from './Summary'
import { UpgradeTideways6 } from './UpgradeTideways6'

interface Props {
    recurlyPricing: any
    upgrade: UpgradeTideways6
    actionUrl: string
    csrfToken: string
}
interface State {
    newPlan: string
    allowConfirm: boolean
}
export default class ChangePlan extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = { newPlan: this.props.upgrade.newPlan, allowConfirm: false }
    }
    public render() {
        const projectSizes = {}
        this.props.upgrade.applications.forEach(application => {
            projectSizes[application.id] = application.projectSize
        })
        const interval = this.props.upgrade.currentPlan.endsWith('_1y') ? PaymentInterval.Yearly : PaymentInterval.Monthly

        return (
            <div>
                <form method="POST" action={this.props.actionUrl}>
                    <input type="hidden" name="plan" value={this.state.newPlan} data-recurly="plan" />
                    <input type="hidden" name="_csrf[billing]" value={this.props.csrfToken} />

                    <SelectTideways6Plans
                        recurlyPricing={this.props.recurlyPricing}
                        upgrade={this.props.upgrade}
                        onPlanChange={(plan: string) => this.setState({ newPlan: plan, allowConfirm: true })}
                        selectedPlan={this.state.newPlan}
                        interval={interval}
                    />

                    <h4>Summary</h4>

                    <Summary
                        recurlyPricing={this.props.recurlyPricing}
                        upgrade={this.props.upgrade}
                        newPlan={this.state.newPlan}
                        coupon={this.props.upgrade.coupon}
                        currency={this.props.upgrade.currency}
                        projectSizes={projectSizes}
                        interval={interval}
                    />

                    <div className="row">
                        <div className="col-lg-12 centered">
                            <a className="btn btn-default" onClick={() => history.back()}>
                                Back
                            </a>

                            <button className="btn btn-primary" type="submit" disabled={!this.state.allowConfirm}>
                                Confirm plan change with obligation to pay
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}
